import { observer } from 'mobx-react-lite';
import React, { useContext, useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Button, Grid } from 'semantic-ui-react';

import LoadingComponent from '../../../app/layout/LoadingComponent';
import { QrTicketFiltersFormValues } from '../../../app/models/qrticket';
import { RootStoreContext } from '../../../app/stores/rootStore';
import QrTicketFilters from './QrTicketFilters';
import QrTicketList from './QrTicketList';

interface DetailParams {
  id: string;
}

const QrTicketDashboard: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { loadDepositSalesTicket } = rootStore.depositSalesTicketStore;
  const {
    loading,
    searchMode,
    loadQrTicketAttributes,
    setSearchMode,
    setQrTicketFilters,
  } = rootStore.qrTicketStore;

  useEffect(() => {
    loadQrTicketAttributes();
    loadDepositSalesTicket(match.params.id);
    const filters = new QrTicketFiltersFormValues();
    filters.salesId = parseInt(match.params.id, 10);
    setQrTicketFilters(filters);
  }, [
    loadQrTicketAttributes,
    loadDepositSalesTicket,
    match.params.id,
    setQrTicketFilters,
  ]);

  if (loading) {
    return <LoadingComponent content='Loading...' />;
  }

  return (
    <Grid>
      <Grid.Column width={16}>
        <Button
          content='検索条件'
          icon={searchMode ? 'angle up' : 'angle down'}
          onClick={() => setSearchMode(!searchMode)}
        />
        {searchMode && <QrTicketFilters salesId={match.params.id} />}
        <QrTicketList salesId={match.params.id} />
      </Grid.Column>
    </Grid>
  );
};

export default observer(QrTicketDashboard);
